import cookie from 'js-cookie'
import { PLATFORM_TYPE } from '../../constants/global-variable.enum'

const NPP_COOKIE_KEY = 'NPP'
const NPP_MORITOR_INTERVAL = 1000
const NPP_MEMBER_SN_INDEX = {
  [PLATFORM_TYPE.KRPC]: 2, // NP11:auth:151353791:test 형태
  [PLATFORM_TYPE.JPPC]: 3, // NP12:sso:0:738693762:test 형태
}

function extractMemberSn(npp, index) {
  if (typeof npp !== 'string' || !npp.length) return null;
  const parts = npp.split(':');
  return parts.length > index ? parts[index] : null;
}

function startNppMonitor({ platformType }) {
  const extractIndex = NPP_MEMBER_SN_INDEX[platformType]
  const initialNpp = cookie.get(NPP_COOKIE_KEY) || null
  const initialMemberSn = extractMemberSn(initialNpp, extractIndex)

  const intervalId = setInterval(() => {
    const currentNpp = cookie.get(NPP_COOKIE_KEY) || null
    const currentMemberSn = extractMemberSn(currentNpp, extractIndex)
    if (currentMemberSn !== initialMemberSn) {
      clearInterval(intervalId)
      window.location.reload()
    }
  }, NPP_MORITOR_INTERVAL)
}

function startNppMonitorWhenDocumentHidden({ platformType }) {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === "hidden") {
      startNppMonitor({ platformType })
    }
  })
}

export function initNppMonitor({ use, platformType }) {
  if (use) {
    startNppMonitor({ platformType })
  } else if (use === undefined) { // 기본 옵션: 포커스 여부
    startNppMonitorWhenDocumentHidden({ platformType })
  }
}